import React, { useContext, useEffect } from 'react'
import { Outlet } from 'react-router'
import { StoresContext } from '@App/contexts'

const MatchHistoryLayout = () => {
    const { matchingStore, matchHistoryStore } = useContext(StoresContext)
    // Clearing the stores here does not clear the query cache, which keeps the fetched page. On the way back the
    // search is a cache hit, so the results are refilled by `useSearchQuery`'s `applyData`, not by a fetch.
    useEffect(() => () => {
        matchingStore.resetStore()
        matchHistoryStore.resetStore()
    })

    const outletContextValue = {
        isSongwriterHub: location.pathname.startsWith('/songwriter'),
    }

    return (
        <>
            <title>Match History</title>
            <Outlet context={outletContextValue} />
        </>
    )
}

export default MatchHistoryLayout
